export default __webpack_public_path__ + "static/media/84t.2378384d.jpg";